import { CouponsRepository } from '@lib/api/repository/coupons';
import {
  CouponQuoteInput,
  CouponScope,
  SaveCouponInput,
} from '@lib/types/coupons';

export default class CouponsService {
  constructor(private readonly repository: CouponsRepository) {}

  list(scope: CouponScope, page: number, signal?: AbortSignal) {
    return this.repository.list(scope, page, signal);
  }

  archive(scope: CouponScope, id: string) {
    return this.repository.archive(scope, id);
  }

  save(input: SaveCouponInput) {
    return this.repository.save(input);
  }

  usages(scope: CouponScope, id: string, page: number, signal?: AbortSignal) {
    return this.repository.usages(scope, id, page, signal);
  }

  quote(input: CouponQuoteInput, signal?: AbortSignal) {
    return this.repository.quote(input, signal);
  }
}
